import { useNavigate } from 'react-router-dom'
import { ICourse } from '@/shared/ICourse';
import { CourseStorageService } from '../services/CourseStorageService';
import { CourseDialog } from './CourseDialog';
import { PLATFORM_VERSION } from '@/shared/constants';
import { makeAcronym } from '@/shared/parse';

export const NewCourseDialog = (props: {
  onClose: () => void;
  platformVersion: PLATFORM_VERSION;
  isDisabled: boolean;
}) => {

  const navigate = useNavigate();

  const defaultCourse: ICourse = {
    id: '',
    folderName: '',
    CourseTitle: '',
    CourseIdentifier: '',
    CourseProviderUsers: [],
    CourseStaffUsers: [],
    CourseStep: '',
    CourseStatus: 'new',
    providerId: '',
    expertId: '',
    coursePlatformVersion: props.platformVersion
  };

  const onSaveCourse = async (data: ICourse) => {
    const course: ICourse = await CourseStorageService.createCourse({
      ...data,
      CourseIdentifier: data.CourseIdentifier || makeAcronym(data.CourseTitle || ''),
    });
    navigate(`/course/${course.id}`);
  }

  return (
    <CourseDialog
      course={defaultCourse}
      onClose={props.onClose}
      onSave={onSaveCourse}
      title={`Add New Course ${props.platformVersion === PLATFORM_VERSION.V1 ? '(V1)' : ''}`}
      description='This will create a submission for a new course (not yet run for EIT UM).'
      saveLabel='Add New Course'
      savingLabel='Adding New Course...'
    />
  )
}